import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { graphql } from 'gatsby';

import Layout from '~/components/Layout';
import Seo from '~/components/SEO';
import CompanyBottomNav from '~/components/CompanyBottomNav';
import Image from '~/components/Dynamic/Image';

import useStoryblok from '~/utils/storyblok-service';

function Impact({ data, location, pageContext }) {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story.content;

  const { hero, introHeading, people, planet, product, promise, button } = content;

  return (
    <Layout locale={pageContext.locale}>
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />

      <section className="relative z-0 pt-24 mb-24 -mt-16 overflow-hidden bg-beige">
        <div className="absolute inset-0 w-full h-full pointer-events-none">
          <StaticImage
            src={`../assets/images/social-impact/impact-background.png`}
            loading="eager"
            alt="hero background"
            className="w-full"
            objectFit="cover"
            placeholder="blurred"
          />
        </div>

        <div className="container relative z-10 flex flex-col items-center justify-center py-20 md:py-40 pt-42">
          <div className="flex flex-col items-center justify-center max-w-3xl">
            <h1 className="font-normal text-center lg:text-72px text-h1">{hero[0]?.heading}</h1>
            <div className=" text-center text-20px max-w-[621px] mt-8 ">
              <p>{hero[0]?.content}</p>
            </div>
          </div>

          <div className="max-w-lg mt-24 text-center md:mt-56">
            <h2 className="font-normal md:text-50px u-h2">{introHeading}</h2>
          </div>

          <div className="flex flex-col items-center justify-center text-center mt-28 max-w-[720px]">
            <Image blok={product[0]?.icon} imageClassName="mx-auto" />
            <div className="mt-16">
              <h3 className="font-normal leading-none tracking-tight text-38px font-heading ">{product[0]?.heading}</h3>
              <div className="mt-5 leading-normal tracking-tighter prose text-black text-16px">
                <p>{product[0]?.content}</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center text-center mt-28 max-w-[720px]">
            <Image blok={people[0]?.icon} imageClassName="mx-auto" />

            <div className="mt-16">
              <h3 className="font-normal leading-none tracking-tight text-38px font-heading ">{people[0]?.heading}</h3>
              <div className="mt-5 leading-normal tracking-tighter prose text-black text-16px">
                <p>{people[0]?.content}</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center text-center mt-28 max-w-[720px]">
            <Image blok={planet[0]?.icon} imageClassName="mx-auto" />
            <div className="mt-16">
              <h3 className="font-normal leading-none tracking-tight text-38px font-heading ">{planet[0]?.heading}</h3>
              <div className="mt-5 leading-normal tracking-tighter prose text-black text-16px">
                <p>{planet[0]?.content}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-20 md:my-28">
        <div className="container flex flex-col items-center justify-center">
          {promise.map((promiseList, i, arr) => (
            <div
              key={`promiseList${i}`}
              className={`flex flex-col max-w-lg ${i !== 0 && i !== arr.length - 1 && 'my-16 md:my-28'}`}
            >
              <h3 className="font-normal leading-none tracking-tight text-38px font-heading">{promiseList?.heading}</h3>
              <div className="mt-8 md:mt-12 square-list--black">
                <ul>
                  {promiseList?.listItem.map((item, i) => (
                    <li key={`promiseListItem${i}`}>{item?.listItem}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CompanyBottomNav items={button} />
    </Layout>
  );
}

export default Impact;

export const query = graphql`
  query ImpactQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
